import VariationData from "../components/VariationData";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;

const Variation = () => {
  let { groupElementId, levelId, elementId } = useParams();
  const [technicName, setTechnicName] = useState("");
  const [levelName, setLevelName] = useState("");
  const [elementName, setElementName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseLevel = await axios.get(apiUrl + `levels/${levelId}`);
        const responseTechnic = await axios.get(apiUrl + `group_elements/${groupElementId}`);
        const responseElement = await axios.get(apiUrl + `elements/${elementId}`);
        setLevelName(responseLevel.data);
        setTechnicName(responseTechnic.data);
        setElementName(responseElement.data.name);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [elementId]); // Effect se déclenche à chaque changement d'ID

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  //TODO mettre la navigation vers le bon moment après l'update ou le delete 
    return (
      <div className="TechnicContainer">
        <div className="Title">

          <Link className="BackButton" to={{
            pathname: "/technic/" + groupElementId + "/level/" + levelId ,
          }}>
              <img src="./back.png" />
          </Link>
                     
              
          <div className="TitleElement">
            <a>{technicName.toUpperCase()}</a>
            <a>{levelName.toUpperCase()}</a>
            <a>{elementName.toUpperCase()}</a>
            
          </div>
        </div>
        
        <div className="TechnicArea">
          <VariationData groupElementId={groupElementId} levelId={levelId} elementId={elementId}/>

          {sessionStorage.getItem("role") == 1 ? (
            <Link className="AddButton" to={{
              pathname: "/technic/" + groupElementId + "/level/" + levelId + "/variation/" + elementId + "/variation_new",
          }}>
              <img src="./plus.png" />
          </Link>
          ) : (
            null
          )}
          
        </div>
      </div>
      )
    };  
    export default Variation;